import { render, staticRenderFns } from "./bidWinAnnouncementEdit.vue?vue&type=template&id=3db9084b&scoped=true"
import script from "./bidWinAnnouncementEdit.vue?vue&type=script&lang=js"
export * from "./bidWinAnnouncementEdit.vue?vue&type=script&lang=js"
import style0 from "./bidWinAnnouncementEdit.vue?vue&type=style&index=0&id=3db9084b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db9084b",
  null
  
)

export default component.exports